import {TimelineLite, TimelineMax} from "gsap";
import {Mental} from "../Mental";
import {IFinalEvaluatedArea, IMentalGameData} from "../server/MentalData";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

export class XWaysCounter extends PIXI.Container {
    public _xWaysCounterValue: number[] = [3, 2, 3, 2, 3];
    public _stickyFFCounterForFS: number[] = [0, 0, 0, 0, 0];
    private _xWaysCounter: PIXI.BitmapText;
    private readonly _xWaysCounterContainer: PIXI.Container;

    constructor() {
        super();
        this._xWaysCounterContainer = new PIXI.Container();
        this.createCounter();
        this._xWaysCounterContainer.addChild(this._xWaysCounter);
        this.addChild(this._xWaysCounterContainer);
    }

    public updateXwaysCounter(reset: boolean = false, isFinal: boolean = false): void {
        if (reset) { // added this code to add sticky ff ways with normal ways
            for (let i = 0; i < this._xWaysCounterValue.length; i++) {
                this._xWaysCounterValue[i] += this._stickyFFCounterForFS[i];
            }
        }

        const counter: PIXI.BitmapText = this._xWaysCounter;
        const from: string = counter.text;
        const to: number = isFinal ? this.getFinalXwaysCount() : this._xWaysCounterValue.reduce((a: number, b: number) => a * b);
        const duration: number = reset ? 0.0001 : 0.2; // to fix # 56, updated in #92

        const tl: TimelineMax = new TimelineMax({
            onUpdate: () => {
                counter.text = Math.round(Number(counter.text)).toString();
                counter.pivot.set(counter.width / 2, counter.height / 2);
                const scale: number = Math.min(120 / (this._xWaysCounter.width), 1);
                this._xWaysCounterContainer.scale.set(scale);
            },
            onComplete: () => {
                counter.text = Math.round(to).toString();
                counter.pivot.set(counter.width / 2, counter.height / 2);
                const scale: number = Math.min(120 / (this._xWaysCounter.width), 1);
                this._xWaysCounterContainer.scale.set(scale);

                // #92
                if (reset) {
                    this._xWaysCounter.tint = 0x777777;
                } else {
                    this._xWaysCounter.tint = 0xbbbbbb;
                }
            }
        });
        // #92
        tl.add(() => {
            if (!reset && counter.text !== (to + "")) {
                this._xWaysCounter.tint = 0xffffff;
            }
        }, 0);

        tl.fromTo(counter, duration, {text: from}, {text: to + ""});
    }

    public updateXwaysCounterFromDead(reelId: number, multiplier: number, diff: number): void {
        this._xWaysCounterValue[reelId] += multiplier - diff;
        this.updateXwaysCounter();
    }

    public updateXwaysCounterFromS2Transform(reelId: number, multiplier: number): void {
        this._xWaysCounterValue[reelId] += multiplier;
        this.updateXwaysCounter();
    }

    public updateXwaysCounterFromMidSym(reelId: number, multiplier: number): void {
        this._xWaysCounterValue[reelId] += multiplier;
        this.updateXwaysCounter();
    }

    public updateXwaysCounterFromS2Xways(reelId: number): void {
        this._xWaysCounterValue[reelId] += 2;
        this.updateXwaysCounter();
    }

    public updateXwaysCounterFromEnhancerXways(reelId: number): void {
        this._xWaysCounterValue[reelId] += 3;
        this.updateXwaysCounter();
    }

    public updateXwaysCounterFromXSplit(reelId: number): void {
        this._xWaysCounterValue[reelId]++;
        this.updateXwaysCounter();
    }

    public updateXwaysCounterFromXNudge(reelId: number): void {
        this._xWaysCounterValue[reelId]++;
        this.updateXwaysCounter();
    }

    public updateXwaysCounterFromEnhancerOpen(reelId: number): void {
        this._xWaysCounterValue[reelId]++;
        this.updateXwaysCounter();
    }

    public updateFinalXwaysCounter(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        tl.add(() => this.updateXwaysCounter(false, true), 0);

        return tl;
    }

    public getFinalXwaysCount(): number {
        const gameData: IMentalGameData = Mental.model.gameData,
            finalEvaluatedArea: IFinalEvaluatedArea[][][] = gameData.finalEvaluatedArea;

        let calcTotalWays: number = 1;

        for (let i: number = 0; i < finalEvaluatedArea.length; i++) {
            let waysPerReel: number = 0;
            const reelEvalArea: IFinalEvaluatedArea[][] = finalEvaluatedArea[i];
            for (let j: number = 0; j < reelEvalArea.length; j++) {
                const allSyms: IFinalEvaluatedArea[] = reelEvalArea[j];
                for (let k: number = 0; k < allSyms.length; k++) {
                    const symObj: IFinalEvaluatedArea = allSyms[k];
                    if (symObj.multiplierOccurrence > 0) {
                        waysPerReel += ((symObj.multiplier * symObj.multiplierOccurrence) + symObj.size) - symObj.multiplierOccurrence;
                    } else {
                        waysPerReel += symObj.size;
                    }
                }
            }
            calcTotalWays *= waysPerReel;
        }

        Logger.logDev("totalWays:", calcTotalWays);

        return calcTotalWays;
    }

    private createCounter(): void {
        this._xWaysCounter = new PIXI.BitmapText("000", {
            fontName: "xNudgeWinCountUp",
            fontSize: 20,
            align: "center",
            tint: 0x777777,
            maxWidth: 120
        });
        this.updateXwaysCounter(true); // as per initial reel set
        // this._xWaysCounter.pivot.set(this._xWaysCounter.width / 2, this._xWaysCounter.height / 2);
        this._xWaysCounterContainer.position.set(144 + this._xWaysCounter.width - 15, 198 - this._xWaysCounter.height);
    }
}